/**
 * Typed mirror of /colors_and_type.css. Use these in R3F materials and any
 * other place where CSS custom properties cannot be referenced.
 */
export const tokens = {
  blue: {
    50:  "#EAF1FB",
    300: "#A6C2F7",
    500: "#1E5BD8",
    700: "#0E2F6E",
    800: "#0E2452",
    900: "#05122E",
  },
  semantic: {
    success: "#16A34A",
    warn:    "#D97706",
    danger:  "#DC2626",
    info:    "#0E7CD3",
  },
  ink: { 900: "#0B0E14", 700: "#384053", 500: "#6B7588" },
  /** --color-heat-0..4 — the viridis occupancy ramp, cold → hot. */
  heat: ["#440154", "#3B528B", "#21908C", "#5DC863", "#FDE725"],
  /** --op-expiry-0..4 — the Validade paint ramp (ADR 354), expired → far-dated.
   *  Ends anchor on --op-danger and a brightened green (ADR 361: success proper
   *  was unreadable against ink-500 grey on the dark floor);
   *  the middle steps exist only for this ramp. */
  expiry: ["#DC2626", "#EA580C", "#EAB308", "#84CC16", "#22C55E"],
  /** --op-unvisited / --op-inferred (ADR 428): count states that are not readings. */
  count: { unvisited: "#FACC15", inferred: "#8B5CF6" },
  font: {
    display: '"Sora", system-ui, sans-serif',
    body:    '"Inter", system-ui, sans-serif',
    mono:    '"JetBrains Mono", ui-monospace, monospace',
  },
  scene: {
    bgBottom: "#05122E",
    bgTop:    "#0E2452",
    ground:   "#0B1B3B",
    grid:     "#112258",  // op-blue-300 at ~8 % opacity on scene bg — hex avoids THREE.Color alpha warning
    /** Timber deck under a racked load. Deliberately outside the status palette:
     *  the pallet is never a state, it is the thing the state is about. */
    pallet:   "#8A6A45",
  },
} as const;

export type Tokens = typeof tokens;
